import React from 'react';
import { FiGlobe } from 'react-icons/fi';
import { FaPassport, FaIdCard, FaIdBadge, FaFileSignature } from 'react-icons/fa';

const KycStep1 = ({ formData, errors, onInputChange, countries }) => {
  const documentTypes = [
    { value: 'passport', label: 'Passport', icon: <FaPassport /> },
    { value: 'national_id', label: 'National ID', icon: <FaIdCard /> },
    { value: 'drivers_license', label: 'Driver\'s License', icon: <FaIdBadge /> },
    { value: 'residence_permit', label: 'Residence Permit', icon: <FaFileSignature /> }
  ];

  return (
    <div className="bg-gray-900 rounded-xl p-6">
      <h2 className="text-2xl font-bold text-white mb-2">📋 Document Information</h2>
      <p className="text-gray-400 mb-6">Select your document type and country</p>
      
      <div className="space-y-6">
        {/* Document Type */}
        <div>
          <label className="block text-gray-300 mb-3">Document Type *</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {documentTypes.map(doc => (
              <button
                key={doc.value}
                type="button"
                onClick={() => onInputChange('document_type', doc.value)}
                className={`p-4 rounded-lg border-2 flex flex-col items-center justify-center transition-all ${
                  formData.document_type === doc.value
                    ? 'border-blue-500 bg-blue-900/20 text-white'
                    : 'border-gray-700 bg-gray-800 text-gray-400 hover:border-gray-600 hover:text-white'
                }`}
              >
                <span className="text-2xl mb-2">{doc.icon}</span>
                <span className="text-sm font-medium">{doc.label}</span>
              </button>
            ))}
          </div>
          {errors.document_type && (
            <p className="mt-2 text-sm text-red-400">{errors.document_type}</p>
          )}
        </div>

        {/* Document Country */}
        <div>
          <label className="block text-gray-300 mb-2 flex items-center gap-2">
            <FiGlobe className="w-5 h-5" />
            Document Issuing Country *
          </label>
          <select
            value={formData.document_country}
            onChange={(e) => onInputChange('document_country', e.target.value)}
            className={`w-full bg-gray-800 text-white px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.document_country ? 'border-red-500' : 'border-gray-700'
            }`}
          >
            <option value="">Select Country</option>
            {countries.map(country => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
          {errors.document_country && (
            <p className="mt-2 text-sm text-red-400">{errors.document_country}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default KycStep1;